<template>
  <div class="homepage">
    <el-card>  
      <el-row :gutter="12" class="row-position">
        <el-col :span="6">
          <el-card shadow="always" class="card-style">
            <div class="title-style">
              <span>{{$t('lang.lab_todayEnrollNum')}}</span>
            </div>
            <div class="content-style">
              <span>{{ form.todayEnrollNum }}</span>
            </div>
            <el-divider class="divider-style"></el-divider>
            <div class="note-style">
              <span class="margin-r20">{{$t('lang.lab_yesterdayEnrollNum')}}</span>
              <span>{{ form.yesterdayEnrollNum }}</span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="always" class="card-style">
            <div class="title-style">
              <span>{{$t('lang.lab_todayVisitNum')}}</span>
            </div>
            <div class="content-style">
              <span>{{ form.todayVisitNum }}</span>
            </div>
            <el-divider class="divider-style"></el-divider>
            <div class="note-style">
              <span class="margin-r20">{{$t('lang.lab_yesterdayVisitNum')}}</span>
              <span>{{ form.yesterdayVisitNum }}</span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="always" class="card-style">
            <div class="title-style">
              <span>{{$t('lang.lab_totalEnrollNum')}}</span>
            </div>
            <div class="content-style">
              <span>{{ form.totalEnrollNum }}</span>
            </div>
            <el-divider class="divider-style"></el-divider>
            <div class="note-style">
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="always" class="card-style">
            <div class="title-style">
              <span>{{$t('lang.lab_totalVisitNum')}}</span>
            </div>
            <div class="content-style">
              <span>{{ form.totalVisitNum }}</span>
            </div>
            <el-divider class="divider-style"></el-divider>
            <div class="note-style">
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 未读消息 -->
      <el-card class="card-width">
        <div class="header-style">
          <!-- 标题 未读消息 -->
          <span class="left">{{$t('lang.lab_unreadMessages')}}</span>
          <!-- 更多link -->
          <el-link class="right" @click="onMore">{{$t('lang.lab_more')}}</el-link>
        </div> 
        <!-- 表格 -->
        <el-table
          class="wid100"
          :data="tableData"
          :row-class-name="tableRowClassName"
          height="289px"
        >
          <!-- 序号 -->
          <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_number')" width="100px" sortable></el-table-column>
          <!-- 标题 -->
          <el-table-column prop="title" :label="$t('lang.lab_title')"></el-table-column>
          <!-- 状态 -->
          <el-table-column prop="readStatus" :label="$t('lang.lab_readStatus')">
            <template slot-scope="scope">
              <!-- 0: 未读 -->
              <span v-if="scope.row.readStatus === 0">{{$t('lang.Message_status[1].name')}}</span>
              <!-- 1: 已读 -->
              <span v-if="scope.row.readStatus === 1">{{$t('lang.Message_status[2].name')}}</span>
            </template>      
          </el-table-column>
          <!-- 时间 -->
          <el-table-column prop="messageTime" :label="$t('lang.lab_messageTime')">
            <template slot-scope="scope">
              {{ scope.row.messageTime  | time }}
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
            <template slot-scope="scope">
              <el-button @click="onDetail(scope.row)">{{$t('lang.btn_detail')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-card>
    <!-- 查看 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      class="form-position"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="cForm" ref="cForm" label-width="120px" label-suffix=":">
        <!-- 消息时间 -->
        <el-form-item :label="$t('lang.lab_messageTimes')">
          <span>{{ cForm.messageTime | time }}</span>
        </el-form-item>
        <!-- 消息类型 -->
        <el-form-item :label="$t('lang.lab_messageTypeName')">
          <span>{{ cForm.messageTypeName }}</span>
        </el-form-item>
        <el-divider></el-divider>
        <!-- 标题 -->
        <el-form-item :label="$t('lang.lab_messageTitle')">
          <span>{{ cForm.title }}</span>
        </el-form-item>
        <!-- 赛事名称 -->
        <el-form-item :label="$t('lang.lab_competeName')">
          <span>{{ cForm.competeName }}</span>
        </el-form-item>
        <!-- 赛事项目-线上赛无赛事项目(competeTyp:0线下1线上) -->
        <el-form-item :label="$t('lang.lab_competeItem')" v-if="cForm.competeType === 0">
          <span>{{ cForm.competeItemName }}</span>
        </el-form-item>
        <!-- 缴纳费用 -->
        <el-form-item :label="$t('lang.lab_fee')">
          <span>{{ cForm.fee }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="toComfirm">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
	</div>
</template>

<script>
/**
 *@ClassName:homepage
 *@Description:首页
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-18
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 查看dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_detail'), // 查看dialog的title
      pageNum: 1,
      pageSize: 5,
      readStatus: 0,
      form: {
        id: 0,
        todayEnrollNum: 0,
        todayVisitNum: 0,
        totalEnrollNum: 0,
        totalVisitNum: 0,
        yesterdayEnrollNum: 0,
        yesterdayVisitNum: 0        
      },
      tableData: [], // 场次管理列表数据
      cForm: {
        id: '',
        competeItemName: '',
        competeName: '',
        fee: '',
        messageTime: '',
        messageType: '',
        messageTypeName: '',
        readStatus: '',
        title: '',      
        competeType: 0,  
      }, // 详细数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取总览数据
    getData() {
      this.$get('/sys/overview').then(
        res => {
          if (res && res.code === 200) {
            this.form = res.data
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取未读消息数据
    getListData() {
      let params = {
        readStatus: this.readStatus,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$postJson('/message/filterMessage', params).then(
        res => {
          if (res && res.code === 200) {
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 更多
    onMore() {
      this.$router.push('/manage/message')
    },    
    // 详情
    onDetail(data) {
      this.cForm.competeType = data.competeType
      this.cForm.id = data.id
      this.cForm.competeItemName = data.competeItemName
      this.cForm.competeName = data.competeName
      this.cForm.fee = data.fee + this.$i18n.t('lang.lab_yuan')
      this.cForm.messageTime = data.messageTime
      this.cForm.messageType = data.messageType
      this.cForm.messageTypeName = data.messageTypeName
      this.cForm.readStatus = data.readStatus
      this.cForm.title = data.title 
      this.isShow = true
      this.$get(`/message/readStatus?sysMessageId=${this.cForm.id}`).then(
        res => {
          if (res && res.code === 200) {
            // 更新列表
            this.getListData()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )     
    },
    // 确定
    toComfirm() {
      this.handleDialogClosed()
    },
    // 监听关闭'查看'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.cForm.competeType = ''
      this.cForm.id = ''
      this.cForm.competeItemName = ''
      this.cForm.competeName = ''
      this.cForm.fee = ''
      this.cForm.messageTime = ''
      this.cForm.messageType = ''
      this.cForm.messageTypeName = ''
      this.cForm.readStatus = ''
      this.cForm.title = ''   
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
  },
  created() {
    this.getData()
    this.getListData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
.homepage {
  .card-style{
    width: 80%;
    height: 180px;
    text-align:center;
    margin: 0 auto;
    margin-top: 80px;
  }
  .title-style{
    font-size: 1vw;
    width: 100%;
    height: 50px;
    text-align:left;
  }
  .content-style{
    font-size: 30px;
    text-align:center;
    margin: 0 auto;
    width: 100%;
    height: 60px;
  }
  .note-style{
    font-size: 1vw;
    width: 100%;
    height: 30px;
    text-align:left;
  }
  .divider-style{
    width: 100%;
    text-align:center;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-width{
    width: 95%;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 30px;
  }
  .header-style{
    margin-top: 10px;
    margin-bottom: 10px;
    .left{
      margin-left: 10px;
      font-size: 20px;
      text-align:left;
      display: inline-block;
      vertical-align: middle;
    }
    .right{
      margin-right: 10px;
      font-size: 18px;
      float: right;
      vertical-align: middle;
    }
  }
  .margin-r20 {
    margin-right: 20px;
  }
  .row-position{
    padding-right: 100px;
    padding-left: 100px;
  }
  .form-position{
    .el-dialog .el-form {
      padding: 20px 20px 0 20px !important;
    }
  }
}
</style>
